import "./index.scss";
import type {} from "@redux-devtools/extension";
import Questionizer from "./components/questionizer";
import { useEffect, useState } from "react";
import { useQuestionizerStore } from "./types/state";
import Input from "./components/input.tsx";
import { val } from "https://esm.sh/cheerio@1.0.0/dist/esm/api/attributes.d.ts";

function loadConfigWithBase(
  loadConfig: (path: string) => void,
  basePath: string,
  fileName: string
) {
  if (!basePath && !fileName) return;
  loadConfig(basePath + fileName);
}

export default function App(props: { configPath: string | null | undefined }) {
  const [direct, set_direct] = useState(false);

  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const requestStatistics = useQuestionizerStore(
    (state) => state.requestStatistics
  );
  const sendStatisticsInterval = 3000; //3 seconds
const basePath = props.configPath
  ? props.configPath.substring(0, props.configPath.lastIndexOf("/") + 1)
  : "";

  useEffect(() => {
    if (!props.configPath) {
      return;
    }
    if (config) {
      return;
    }

    async function test_address_data() {
      const query = new URLSearchParams(window.location.search);

      const address_street =
        query.get("address_street") ||
        document!
          .querySelector('meta[name="address_street"]')
          ?.getAttribute("content");
      const address_house_number =
        query.get("address_house_number") ||
        document!
          .querySelector('meta[name="address_house_number"]')
          ?.getAttribute("content");
      const address_zip =
        query.get("address_zip") ||
        document!
          .querySelector('meta[name="address_zip"]')
          ?.getAttribute("content");

      console.log("A", address_street, address_house_number, address_zip);
      if (address_street && address_house_number && address_zip) {
        const status = await test_adress(
          address_zip,
          address_house_number,
          address_street
        );

        console.log("LOADDIRECT", status);
        if (status) {
          if (status == "Fernwärmeanschluss möglich") {
			 loadConfigWithBase(loadConfig,basePath,"client-config-fernwaerme-direkt.json");
          } else if (status == "kein Fernwärmeanschluss möglich") {
            loadConfigWithBase(loadConfig,basePath,"client-config-keine-fernwaerme-direkt.json");
          } else {
            loadConfigWithBase(loadConfig,basePath,"client-config-direkt.json");
          }
          set_direct(true);
        }
      } else {
        loadConfigWithBase(loadConfig,basePath,"client-config.json");
      }
    }

    test_address_data();
    requestStatistics();
    const interval = setInterval(() => {
      requestStatistics();
    }, sendStatisticsInterval);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (!props.configPath || !config) {
    return;
  }

  let style = config.style;
  let parsed_style = Object.keys(style)
    .map((element) => [
      element,
      element
        .split(",")
        .map((s) => ".fbq " + s)
        .join(","),
    ])
    .map(
      (element) =>
        `${element[1]}{${Object.keys(style[element[0]])
          .map((s) => `${s.toString()}:${style[element[0]][s]}`)
          .join(";")}}`
    )
    .join(" ");

  if (direct) {
    return (
      <>
        <style>{parsed_style}</style>
        <RootDirect />
      </>
    );
  }

  return (
    <>
      <style>{parsed_style}</style>
      <Root basePath={basePath} />
    </>
  );
}

function Root({ basePath }: { basePath: string }) {
  const [heating_status, set_heating_status] = useState(false);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const address_street = useQuestionizerStore((state) => state.address_street);
  const address_house_number = useQuestionizerStore(
    (state) => state.address_house_number
  );
  const address_zip = useQuestionizerStore((state) => state.address_zip);

  const setAddress_street = useQuestionizerStore(
    (state) => state.setAddress_street
  );
  const setAddress_house_number = useQuestionizerStore(
    (state) => state.setAddress_house_number
  );
  const setAddress_zip = useQuestionizerStore((state) => state.setAddress_zip);

  // const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const setValidationSections = useQuestionizerStore(
    (state) => state.setValidationSections
  );

  const updateValidation = () => {
    let v = {
      valid: false,
      message: "Bitte Adressdaten angeben",
    };

    if (
      heating_status &&
      address_street &&
      address_house_number &&
      address_zip &&
      address_street.length > 4 &&
      address_zip.length > 4
    ) {
      v = {
        valid: true,
        message: "",
      };
    }

    setValidationSections([v]);
  };

  useEffect(() => {
    function set_meta(key: string, value: string | number) {
      if (!value) {
        return;
      }
      console.log("set meta", key, value);
      let meta = document!.querySelector('meta[name="' + key + '"]');
      if (meta) {
        meta.setAttribute("content", value);
      } else {
        meta = document.createElement("meta");
        meta.name = key;
        meta.content = value;
        document!.head.appendChild(meta);
      }
    }

    async function test_adress_data() {
      const status = await test_adress(
        address_zip,
        address_house_number,
        address_street
      );

      if (status) {
        if (status == "Fernwärmeanschluss möglich") {
          loadConfigWithBase(loadConfig,basePath,"client-config-fernwaerme.json");
        } else if (status == "kein Fernwärmeanschluss möglich") {
		  loadConfigWithBase(loadConfig,basePath,"client-config-keine-fernwaerme.json");
        } else {
          loadConfigWithBase(loadConfig,basePath,"client-config.json");
        }
        set_heating_status(true);
      }

      setTimeout(updateValidation, 100);
    }

    set_meta("address_street", address_street);
    set_meta("address_house_number", address_house_number);
    set_meta("address_zip", address_zip || "");

    if (
      address_street &&
      address_house_number &&
      address_zip &&
      address_zip.length > 4
    ) {
      test_adress_data();
    } else {
      setTimeout(updateValidation, 100);
    }
  }, [address_street, address_house_number, address_zip]);

  useEffect(() => {
    updateValidation();
  }, [heating_status]);

  return (
    <div className="form w-full h-full flex flex-col font-sans">
      <Questionizer>
        <h1>Bitte Adresse angeben</h1>

        <div className="flex gap-4">
          <div className="flex-1">
            <Input<string>
              label="Straße"
              value={address_street}
              onChange={(value) => setAddress_street(value)}
              type="text"
            />
          </div>

          <div className="w-24">
            <Input<string>
              label="Hausnr."
              value={address_house_number}
              onChange={(value) => setAddress_house_number(value)}
              type="text"
            />
          </div>

          <div className="w-32">
            <Input<string>
              label="PLZ"
              value={address_zip}
              onChange={(value) => setAddress_zip(value)}
              type="text"
            />
          </div>
        </div>
      </Questionizer>
    </div>
  );
}

function RootDirect() {
  return (
    <div className="form w-full h-full flex flex-col font-sans">
      <Questionizer />
    </div>
  );
}

async function test_adress(
  address_zip: string,
  address_house_number: string,
  address_street: string
) {
  const login_result = await fetch(`https://esrapi.fe-bis.de/api/calc/login`, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Embarcadero-App-Secret": "CBC!ApiEsrCal2025",
    },
    body: JSON.stringify({
      username: "evhhalle",
      password: "E18c6%52jc!d",
    }),
  });
  const login_json = await login_result.json();
  if (!login_json || !("session_token" in login_json)) {
    return;
  }

  const result = await fetch(
    `https://esrapi.fe-bis.de/api/calc/check_district_heating_status?sessionToken=${login_json["session_token"]}`,
    {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Embarcadero-App-Secret": "CBC!ApiEsrCal2025",
      },
      body: JSON.stringify({
        zip: address_zip,
        num: address_house_number,
        street: address_street,
      }),
    }
  );
  const json = await result.json();
  return json["status"];
}
